// extracted by mini-css-extract-plugin
export default {"root":"BannerTop-root","buttonClose":"BannerTop-buttonClose"};